import React from "react";
import classes from "./FriendlyInfo.module.scss";
import img_not_found from "./images/img_not_found.png";
import img_wrong_file from "./images/img_wrong_file.png";
// import Auth from "@aws-amplify/auth";

interface Interface {
  className?: string;
  wrong_file?: boolean;
  subtext?: string | null;
  text?: string | null;
  isError?: boolean;
  children?: any;
}

export default function FriendlyInfo({
  className = "", // default
  wrong_file = false,
  isError = false,
  subtext,
  text,
  children,
}: Interface) {
  // if (Auth) console.log("Auth.user", Auth);

  let img = img_not_found;
  if (!text) text = "Nenhuma informação encontrada com essa busca :(";
  if (wrong_file) {
    img = img_wrong_file;
    if (!text)
      text = "Arquivo não reconhecido, por favor utilize o modelo como base";
  }
  className += " " + classes.FriendlyInfo;
  if (isError) className += " " + classes.IsError;
  return (
    <div className={className}>
      <figure>
        <img src={img} alt="" />
        <figcaption>
          <span className={classes.Text}>{text}</span>
          {subtext && <span className={classes.SubText}>{subtext}</span>}
        </figcaption>
      </figure>
      {children && <div className={classes.Bottom}>{children}</div>}
    </div>
  );
}
